// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GithubAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC8ejPa6KG9oIUX_SUqdDZDRpoSlnAmH_A",
  authDomain: "dynamic-form-270.firebaseapp.com",
  projectId: "dynamic-form-270",
  storageBucket: "dynamic-form-270.firebasestorage.app",
  messagingSenderId: "321607643030",
  appId: "1:321607643030:web:b0169bd46f5a600bf037b7",
  measurementId: "G-RNBKSDDXB0"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();

export { auth, db, googleProvider, githubProvider };